<div class="filter_box">
  <div class="filter_button">
    <app-button
      [buttonSize]="'action'"
      [buttonStyle]="'text'"
      (click)="resetColumn()"
      >Reset</app-button
    >
  </div>
  <ng-container *ngFor="let group of groupNames">
    <div class="filter_column" *ngIf="group !== 'undefined'">
      <div class="filters_title">
        <ng-container>{{group}}
        </ng-container>
      </div>
          <ng-container *ngFor="let x of columns[group]">
            <div *ngIf="x.colId != '0'" (click)="selectColumn(x.colId)">
              <div class="input-container" *ngIf="x.colId">
                <div class="input-container_label m-0">
                  <img src="../../../assets/images/tick.svg" alt="" *ngIf="x.visible" />
                  <span [ngClass]="{ 'gray-text': !x.visible }">
                    {{
                    x.userProvidedColDef.headerName
                    ? x.userProvidedColDef.headerName
                    : x.userProvidedColDef.field
                    }}
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
      </div>  
  </ng-container>
</div>
  